import {
  GET_ALL_RISK_MANAGEMENT_SETTING,
  GET_ALL_RISK_MANAGEMENT_SETTING_RESPONSE_SUCCESS,
} from "./actionTypes"

export const getAllRiskManagementSetting = () => {
  return {
    type: GET_ALL_RISK_MANAGEMENT_SETTING,
  }
}
export const getAllRiskManagementSettingResponseSuccess = payload => ({
  type: GET_ALL_RISK_MANAGEMENT_SETTING_RESPONSE_SUCCESS,
  payload: payload,
})
